module.exports = __webpack_public_path__ + "static/media/ice8.f6e487a4.webp";